import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc1ffa00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "place" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "image", {}, undefined, true),
    _renderSlot(_ctx.$slots, "city", {}, undefined, true),
    _renderSlot(_ctx.$slots, "description", {}, undefined, true)
  ]))
}